import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["enumObject", "showBlank", "excludedValues"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context5, _context6; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context5 = ownKeys(Object(t), !0)).call(_context5, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context6 = ownKeys(Object(t))).call(_context6, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
//@ts-nocheck
import React from "react";
import SelectField from "../SelectField/SelectField";

/*
 * Simulating a menu change with Testing library
 *
 *  const selectContainer = getByTestId("theTestId");
 *  const button = getByRole("button", { container: selectContainer });
 *  fireEvent.click(button);
 *  await findByText(/an\soption/i);
 *  const itemClickable = getByText(/an\soption/i);
 *  fireEvent.click(itemClickable);
 */
import { jsx as _jsx } from "react/jsx-runtime";
function EnumSelectField(_ref) {
  var _context, _context2, _context3;
  var enumObject = _ref.enumObject,
    _ref$showBlank = _ref.showBlank,
    showBlank = _ref$showBlank === void 0 ? true : _ref$showBlank,
    _ref$excludedValues = _ref.excludedValues,
    excludedValues = _ref$excludedValues === void 0 ? [] : _ref$excludedValues,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = _mapInstanceProperty(_context = _sortInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$values(_valuesInstanceProperty(enumObject))).call(_context3, function (v) {
    return !_includesInstanceProperty(excludedValues).call(excludedValues, v.value);
  })).call(_context2, function (a, b) {
    return a.order - b.order;
  })).call(_context, function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? "" : _ref2$description;
    return {
      label: label,
      value: value
    };
  });
  if (showBlank) {
    var _context4;
    options = _concatInstanceProperty(_context4 = [{
      label: "",
      value: ""
    }]).call(_context4, _toConsumableArray(options));
  }
  return /*#__PURE__*/_jsx(SelectField, _objectSpread({
    options: options,
    showBlank: showBlank,
    InputLabelProps: {
      style: {
        position: "static"
      }
    }
  }, props));
}
export default EnumSelectField;